var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((this.modules),function(m,i){return _c(_vm.getModuleTagByTypeId(m.moduleTypeId).tag,{key:("module_" + i),tag:"component",attrs:{"settings":m.moduleSettings}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }